import React, {useState} from 'react';
import {Link, useHistory} from "react-router-dom"
import { Nav, Navbar, NavDropdown, Container, Button, Modal, Image} from 'react-bootstrap';
import NotificheButton from './NotificheModal';
import VerificaToken from './VerificaToken';



function NavigationBar() {

    let history = useHistory();

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const {user, setUser} = VerificaToken();

    const login = () => {
        history.push("/account/login");
        handleClose();
    }

    const register = () => {
        history.push("/account/registrati");
        handleClose();
    }
    
    


            const logout = () => {
                setUser();
                localStorage.clear();
                history.push("/");
                };

            


               



                
            

    
    return (
                <Navbar bg="light" expand="lg">
                <Container className="bg-light">
                    <Navbar.Brand><Nav.Link>
                        <Link to={"/"} className="link">
                            <Image className="icon" fluid src="/NavIcon.ico" alt="" />
                        </Link>
                    </Nav.Link></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto bg-light">
                        <NavDropdown title="Lista Veicoli" id="basic-nav-dropdown">
                        <NavDropdown.Item onClick={() => {history.push("/listaVeicoli/listaAuto")}}>Automobili</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {history.push("/listaVeicoli/listaMoto")}}>Motociclette</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {history.push("/listaVeicoli/listaBici")}}>Biciclette</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {history.push("/listaVeicoli/listaMonopattini")}}>Monopattini</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item onClick={() => {history.push("/listaVeicoli")}}>Tutti i Veicoli</NavDropdown.Item>
                        </NavDropdown>
                        {user && user.tipo === "Amministratore" && (<NavDropdown title="Amministrazione" id="basic-nav-dropdown">
                            <NavDropdown.Item onClick={() => {history.push("/amministratore/listaImpiegati")}}>Lista Impiegati</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item onClick={() => {history.push("/amministratore/listaParcheggi")}}>Lista Parcheggi</NavDropdown.Item>
                        </NavDropdown>)}
                        {user && ( <>{user.tipo === "Cliente" ? 
                        (<Nav.Link onClick={() => {history.push(`/prenotazioni/ListaPrenotazioni/${user.id}`)}}>Prenotazioni</Nav.Link>)
                         : (<Nav.Link onClick={() => {history.push(`/incarichi/ListaIncarichi/${user.id}`)}}>Incarichi</Nav.Link>)}</>)}
                        <Nav.Link onClick={() => {history.push("/Chi Siamo")}}>Chi siamo</Nav.Link>
                        
                        
                    </Nav>
                    </Navbar.Collapse>
                    {user && (
                        <Button variant="dark" onClick={logout}>Logout</Button>
                    )}
                    <>
                        {user ? (<Button onClick={() => {history.push(`/account/info/${user.id}`)}} id="accountButton">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" style={{width:'2.5rem'}} height="8" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                        <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                            </svg>
                            
                            </Button>) 
                            : (
                        <Button onClick={handleShow} id="accountButton">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8" style={{width:'2.5rem'}} height="8" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                        <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                                </svg>
                        </Button>
                        )}
                        
                
                        <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Area Personale</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <h5 style={{color: 'cornflowerblue'}}>Per accedere all'area personale devi fare l'accesso o registrarti!</h5>
                        </Modal.Body>
                            
                            <Modal.Footer>
                                <Button variant="secondary" onClick={register}>Registrati</Button>
                                <Button variant="primary" onClick={login}>Accedi</Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                    <h5>{user && (user.email)}</h5>
                    {user && (user.tipo === "Cliente") && (
                        <NotificheButton/>
                    )}
                </Container>
               
                
            
            </Navbar>
             
        
           
                
    )
}

export default NavigationBar